import React from 'react';
import PhoneLink from './phone';
import { Link as GatsbyLink } from 'gatsby';
import {
	EventAction,
	EventCategory,
	EventKeys,
	EventValues,
} from '../../../../services/ga';
import AnalyticsFactory from '../../../../services/analytics-factory';
import { window } from 'browser-monads';

export type LinkChildren = React.JSX.Element | string | React.JSX.Element[] | React.ReactNode;
export interface LinkProps {
	children?: LinkChildren;
	onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
	className?: string;
	href?: string;
	title?: string;
	target?: string;
	rel?: string;
	replace?: boolean;
	alt?: string;
}

const Link: React.FC<LinkProps> = ({
	children,
	onClick,
	className,
	href,
	title,
	target,
	...props
}) => {
	const isExternalLink = href?.startsWith('http');
	const isTargetBlank = target === '_blank';
	const internalLink = isTargetBlank || href === '/' ? `${window.location.origin}${href}` : `${window.location.href}${href}`;

	const gaTrack = (e: React.MouseEvent<HTMLAnchorElement>) => {
		//TODO - implement hoc for link with analytics prop similar to Button
		const analytics = AnalyticsFactory.createAnalytics('ga');
		analytics.sendEvent({
			[EventKeys.Event]: EventValues.GAEvent,
			[EventKeys.EventCategory]: EventCategory.Navigation,
			[EventKeys.EventAction]: isExternalLink ? EventAction.ExternalLink : EventAction.InternalLink,
			[EventKeys.EventLabel]: title ?? (children as string),
			[EventKeys.ExternalLink]: isExternalLink ? href : internalLink,
			[EventKeys.ExternalLinkText]: title ?? (children as string),
			[EventKeys.PageURL]: `${window.location.href}`,
			[EventKeys.PageRequestTime]: new Date().getTime(),
		});
		if (onClick) {
			onClick(e);
		}
	};

	return (
		<>
			{isExternalLink || isTargetBlank ? (
				<a
					className={className || 'print:text-font'}
					href={href}
					title={title}
					target={target}
					onClick={gaTrack}
					{...props}>
					{children}
				</a>
			) : (
				<GatsbyLink
					to={href as string}
					className={className}
					onClick={gaTrack}
					title={title}
					{...props}>
					{children}
				</GatsbyLink>
			)}
		</>
	);
};

export default Link;
export { Link, PhoneLink };
